module.exports = __webpack_public_path__ + "media/images/dashboard/generic-02b1603a8a43b21264a8fc89c7612451.jpg";